import { Component, DoCheck, ElementRef, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { TsInputComponent } from 'tsui';

import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './year-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
})
export class YearFormFieldComponent extends FormFieldComponent implements DoCheck {
  @ViewChild(TsInputComponent) private readonly tsInput?: TsInputComponent;

  private _originalValue: number | string | null;

  public editing: boolean = false;
  public value: number | string | null;
  public readonly control = new FormControl<number | string | null>(null);
  // Overrides the inherited Material-specific selector: ts-input has no .mat-form-field-flex to target.
  public readonly commonTargetStylingClass = '.ts-input';

  // Duck-typed contract read by form-field.component.ts to avoid clobbering an in-progress edit.
  get inputControl(): ElementRef | undefined {
    return this.tsInput?.inputElement();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.model[this.fieldDef.name];

    this._originalValue = this.value;

    this.control.setValue(this.value, { emitEvent: false });
    this.updateDisabledState();

    this.control.valueChanges.pipe(takeUntilDestroyed(this.dRef)).subscribe((value) => {
      this.value = value;
    });
  }

  ngDoCheck(): void {
    this.updateDisabledState();
  }

  edit(): void {
    if (!this.editing && !this.isReadonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl?.nativeElement.focus();
      }, 300);
    }
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;

    this.control.setValue(this.value, { emitEvent: false });
  }

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  private updateDisabledState(): void {
    if (this.isDisabled === this.control.disabled) {
      return;
    }

    if (this.isDisabled) {
      this.control.disable({ emitEvent: false });
    } else {
      this.control.enable({ emitEvent: false });
    }
  }
}
